import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../config";

function decodeJwtPayload(token) {
  try {
    const payload = token.split(".")[1];
    const decoded = JSON.parse(atob(payload));
    return decoded || {};
  } catch (e) {
    return {};
  }
}

function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.status === 200 && data.token) {
        const tokenPayload = decodeJwtPayload(data.token);

        const role =
          data.user?.role ||
          data.role ||
          tokenPayload.role ||
          "fpo_admin";

        const fpoId =
          data.user?.fpo_id ||
          data.fpo_id ||
          tokenPayload.fpo_id ||
          1;

        localStorage.setItem("token", data.token);
        localStorage.setItem("role", role);
        localStorage.setItem("fpo_id", String(fpoId));
        localStorage.setItem("email", data.user?.email || tokenPayload.email || email);

        if (role === "super_admin") {
          navigate("/super-admin");
        } else {
          navigate("/dashboard");
        }
      } else {
        alert(data.message || "Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("Login failed. Please check server connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: "100%", maxWidth: 380, margin: "80px auto" }}>
      <h2>Admin Login</h2>

      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: "100%", padding: 10, marginBottom: 10 }}
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: "100%", padding: 10, marginBottom: 10 }}
      />

      <button
        onClick={handleLogin}
        disabled={loading}
        style={{
          width: "100%",
          padding: 10,
          background: "#1976D2",
          color: "#fff",
          border: "none",
        }}
      >
        {loading ? "Logging in..." : "Login"}
      </button>
    </div>
  );
}

export default LoginPage;